<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p>服务器管理</p>
    </div>
    <div class="main-body">
      <el-row style="margin-bottom: 20px;">
        <el-input
          style="width: 300px; margin-right: 20px"
          placeholder="请输入服务器名称/ip地址/网关"
          v-model="condition"
          clearable
        >
          <template slot="prepend"
            ><span class="el-icon-search"></span> </template
        ></el-input>
        <el-button class="w100" type="primary" @click="queryRecordList"
          >查询</el-button
        >
        <el-button class="w100" type="primary" @click="handleAdd"
          >添加服务器</el-button
        >
      </el-row>
      <el-table
        :data="recordList"
        highlight-current-row
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据处理中，请稍候..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          property="operatingSystemVersion"
          label="操作系统版本"
        ></el-table-column>
        <el-table-column
          property="serverName"
          label="服务器名称"
        ></el-table-column>
        <el-table-column
          property="serverIP"
          label="服务器IP地址"
        ></el-table-column>
        <el-table-column
          property="gateway"
          label="服务器配置的网关"
        ></el-table-column>
        <el-table-column
          property="serverStatusDesc"
          label="服务器状态"
        ></el-table-column>
        <el-table-column property="moduleName" label="操作" width="200px">
          <template slot-scope="scope">
            <el-button
              class="w75"
              @click.native.prevent="handleEdit(scope.row)"
              type="primary"
              size="small"
              >编辑</el-button
            >
            <el-button
              class="w75"
              @click.native.prevent="handleDelete(scope.row.id)"
              type="info"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="handlePageChange"
          background
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="editRecord.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="form" :model="editRecord" label-width="140px">
        <el-form-item label="操作系统版本">
          <el-input
            v-model="editRecord.operatingSystemVersion"
            placeholder="请输入操作系统版本"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务器名称">
          <el-input
            v-model="editRecord.serverName"
            placeholder="请输入服务器名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务器IP地址">
          <el-input
            v-model="editRecord.serverIP"
            placeholder="请输入服务器IP地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务器配置的网关">
          <el-input
            v-model="editRecord.gateway"
            placeholder="请输入服务器配置的网关"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="w75" @click="dialogVisible = false">取 消</el-button>
        <el-button class="w75" type="primary" @click="handleCommit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "serverMgmt",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      editRecord: {},
      dialogVisible: false,
      loading: false,
      condition: "",
      total: 0,
      beginIndex: 0,
      pageSize: 10,
      timer: null,
    };
  },
  mounted() {
    this.queryRecordList();
  },

  watch: {
    condition() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.beginIndex = 0;
        this.queryRecordList();
      }, 500);
    },
  },

  methods: {
    handlePageChange(pageNum) {
      this.beginIndex = (pageNum - 1) * this.pageSize;
      this.queryRecordList();
    },

    handleAdd() {
      this.editRecord = {};
      this.dialogVisible = true;
    },

    handleEdit(row) {
      this.editRecord = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },

    handleCommit() {
      this.createOrUpdate(this.editRecord);
    },

    createOrUpdate(params) {
      let self = this;
      self.loading = true;
      this.$http
        .post(
          "/admin/release/server/createOrUpdate",
          this.$qs.stringify(params),
          {
            headers: {
              token: this.token,
            },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.dialogVisible = false;
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleDelete(id) {
      this.$confirm("是否确认删除？").then(() => {
        this.delete(id);
      });
    },

    delete(id) {
      let self = this;
      self.loading = true;
      this.$http
        .get("/admin/release/server/delete?id=" + id, {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    queryRecordList() {
      let self = this;
      self.loading = true;
      this.$http
        .get(
          "/admin/release/server/list?" +
            this.$qs.stringify({
              condition: this.condition,
              beginIndex: this.beginIndex,
              pageSize: this.pageSize,
            }),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
          self.total = res.mdata.total;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/serverMgmt.vue